// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{display:inline-block}:host([hidden]){display:none}.tyl-chip-set{gap:4px;gap:var(--tyl-chip-set-spacing,4px);display:flex;flex-wrap:wrap}.tyl-chip-set--vertical{flex-direction:column}", ""]);
// Exports
module.exports = exports;
